import type * as XLSXType from 'xlsx';

// xlsx is heavy (~hundreds of KB); load it on demand (mirrors lib/export.ts).
const getXLSX = () => import('xlsx');

const headers = [
  'รหัสสินค้า',
  'ชื่อสินค้า',
  'หน่วยฐาน',
  'หน่วยขาย',
  'จำนวนต่อหน่วยฐาน',
  'ราคาขาย',
  'สต๊อกปัจจุบัน',
  'บาร์โค้ด',
  'หมวดหมู่',
  'ต้นทุน',
  'สต๊อกขั้นต่ำ',
  'เปิดขาย',
];

const sampleRows = [
  [
    'WATER600',
    'น้ำดื่ม 600ml',
    'ขวด',
    'ขวด',
    1,
    7,
    0,
    '8851959132018',
    'เครื่องดื่ม',
    4,
    24,
    'ใช่',
  ],
  [
    'WATER600',
    'น้ำดื่ม 600ml',
    'ขวด',
    'แพ็ค',
    12,
    80,
    10,
    '18851959132015',
    'เครื่องดื่ม',
    48,
    24,
    'ใช่',
  ],
  [
    'WATER600',
    'น้ำดื่ม 600ml',
    'ขวด',
    'ลัง',
    24,
    150,
    2,
    '28851959132012',
    'เครื่องดื่ม',
    96,
    24,
    'ใช่',
  ],
  [
    'BREAD001',
    'ขนมปังเนยสด',
    'ชิ้น',
    'ชิ้น',
    1,
    25,
    30,
    '',
    'เบเกอรี่',
    10,
    5,
    'ใช่',
  ],
];

const instructionRows = [
  ['หัวข้อ', 'คำอธิบาย'],
  [
    'รหัสสินค้า',
    'ไม่บังคับ แต่แนะนำให้กรอก ถ้ารหัสเดียวกันหลายแถว ระบบจะรวมเป็นสินค้าตัวเดียวหลายหน่วยขาย',
  ],
  ['ชื่อสินค้า', 'ต้องกรอก ชื่อที่ใช้แสดงใน POS และรายงาน'],
  [
    'หน่วยฐาน',
    'หน่วยเล็กสุดที่ใช้ตัดสต๊อก เช่น ขวด ชิ้น ซอง ถ้าไม่กรอกจะใช้หน่วยขาย',
  ],
  ['หน่วยขาย', 'ต้องกรอก เช่น ขวด แพ็ค ลัง'],
  ['จำนวนต่อหน่วยฐาน', 'ต้องกรอก เช่น 1 แพ็คมี 12 ขวด ให้กรอก 12'],
  ['ราคาขาย', 'ต้องกรอก เป็นบาท เช่น 80'],
  [
    'สต๊อกปัจจุบัน',
    'ไม่บังคับ นับตามหน่วยขายของแถวนั้น ระบบจะแปลงเป็นหน่วยฐาน',
  ],
  [
    'บาร์โค้ด',
    'ไม่บังคับ แต่ห้ามซ้ำกับทุกแถว รวมถึงหน่วยขายของสินค้าเดียวกัน และห้ามขึ้นต้นด้วย QTY',
  ],
  ['หมวดหมู่', 'ไม่บังคับ ถ้าไม่กรอกระบบใช้ ทั่วไป'],
  ['ต้นทุน', 'ไม่บังคับ แต่ต้องมากกว่า 0 ถ้ากรอกสต๊อกปัจจุบันมากกว่า 0'],
  ['สต๊อกขั้นต่ำ', 'ไม่บังคับ จำนวนขั้นต่ำที่ต้องการให้แจ้งเตือน'],
  ['เปิดขาย', 'ไม่บังคับ ค่าเริ่มต้นคือเปิดขาย ใช้ ใช่/ไม่ใช่ หรือ เปิด/ปิด'],
];

export function buildProductImportTemplateWorkbook(
  XLSX: typeof XLSXType,
): XLSXType.WorkBook {
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet([headers, ...sampleRows]),
    'สินค้า',
  );
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet(instructionRows),
    'คำอธิบาย',
  );
  return workbook;
}

export async function downloadProductImportTemplate(): Promise<void> {
  const XLSX = await getXLSX();
  XLSX.writeFile(
    buildProductImportTemplateWorkbook(XLSX),
    'เทมเพลตนำเข้าสินค้า.xlsx',
  );
}
